import React from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentMini from '../layout/content/ContentMini';
import RedefinirSenhaContent from './RedefinirSenhaContent';

class RedefinirSenha extends AbstractComponent {  
    constructor(props) {
        super(props);

        this.state = {
            preload: false,

            erro: '',

            sucesso: ''
        }
    }  

    componentDidMount() {     
        this.onTitulo("Redefinir Senha");
    }

    render() {
        return (   
            <ContentMini
                className="login"

                preload={this.state.preload}                               
                modalErro={this.state.erro} 
                modalSucesso={this.state.sucesso}                                                 

                onCloseAlerta={() => this.setState({erro: ''})}
                onCloseSucesso={() => { this.setState({sucesso: ''}); this.homePage2() }}

                component={(props) => {                     
                    return (
                        <RedefinirSenhaContent
                            {...props}  
                        
                            showPreload={(value) => this.setState({preload: value})}
                            onSucesso={(sucesso) => this.setState({sucesso: sucesso})}
                            onErro={(erro) => this.setState({erro: erro})}      
                            route={(item) => this.props.route(item)}                      
                        />   
                    )
                }}                 
            />                    
        )
    }
}

export default RedefinirSenha;